export const GET_INQUIRY_EMAIL_SETTING = 'GET INQUIRY EMAIL SETTING'
export const UPDATE_INQUIRY_EMAIL_SETTING = 'UPDATE INQUIRY EMAIL SETTING'
export const GET_INQUIRY_STATUS_SETTING = 'GET INQUIRY STATUS SETTING'
export const CREATE_INQUIRY_STATUS_SETTING = 'ADD INQUIRY STATUS SETTING'
export const UPDATE_INQUIRY_STATUS_SETTING = 'UPDATE INQUIRY STATUS SETTING'
export const DELETE_INQUIRY_STATUS_SETTING = 'DELETE INQUIRY STATUS SETTING'
